module.exports = __webpack_public_path__ + "img/20200514_154421.83f36e07.jpg";